import {
  Avatar,
  Box,
  Burger,
  Group,
  Header,
  Image,
  MediaQuery,
  Menu,
  Text,
  UnstyledButton,
  createStyles,
  useMantineTheme,
} from '@mantine/core';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, Logout } from 'tabler-icons-react';
import { AccountTypes } from '../../../enums/account-type';
import { Roles } from '../../../enums/roles-enum';
import useAuth from '../../../hooks/useAuth';
import useLogout from '../../../hooks/useLogout';

const useStyles = createStyles((theme) => ({
  user: {
    display: 'block',
    minWidth: '220px',
    width: '100%',
    padding: theme.spacing.sm,
    color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,

    '&:hover': {
      backgroundColor:
        theme.colorScheme === 'dark'
          ? theme.colors.dark[8]
          : theme.colors.gray[0],
    },
  },

  userMenu: {
    [theme.fn.smallerThan('xs')]: {
      display: 'none',
    },
  },

  userActive: {
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
  },
}));

interface AppHeaderProps {
  opened: boolean;
  setOpened: (open: any) => void;
}

const AppHeader = (props: AppHeaderProps) => {
  const { opened, setOpened } = props;
  const theme = useMantineTheme();
  const { classes, cx } = useStyles();
  const [userMenuOpened, setUserMenuOpened] = useState(false);
  const logout = useLogout();
  const { auth } = useAuth();
  const navigate = useNavigate();

  const avatarUsernameText = auth?.username || auth?.email || 'Guest';
  const avatarRoleText = auth?.role || 'Guest';
  let avatarColor = 'gray';

  if (auth) {
    if (auth.role === Roles.ADMINISTRATOR) {
      avatarColor = 'red';
    } else if (auth.role === Roles.MERCHANT) {
      avatarColor = 'blue';
    } else if (auth.role === Roles.SETTLEMENT) {
      avatarColor = 'green';
    } else if (auth.role === Roles.CHECKER) {
      avatarColor = 'violet';
    }
  }

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Header height={70} p='md'>
      <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
        <MediaQuery largerThan='md' styles={{ display: 'none' }}>
          <Burger
            opened={opened}
            onClick={() => setOpened((o: any) => !o)}
            size='sm'
            color={theme.colors.gray[6]}
            mr='xl'
          />
        </MediaQuery>

        <Group position='apart' sx={{ width: '100%' }}>
          <Box>
            {/* <Link to='/dashboard'> */}
            <Image
              src='/images/xpay-dark.png'
              alt='generic logo'
              width={60}
              onClick={() => setOpened((o: any) => !o)}
            />
            {/* </Link> */}
          </Box>

          {auth?.role && (
            <Menu
              data-cy='menu'
              size={260}
              placement='end'
              transition='pop-top-right'
              className={classes.userMenu}
              onClose={() => setUserMenuOpened(false)}
              onOpen={() => setUserMenuOpened(true)}
              control={
                <UnstyledButton
                  className={cx(classes.user, {
                    [classes.userActive]: userMenuOpened,
                  })}
                >
                  <Group>
                    <Avatar
                      src={undefined}
                      alt={avatarUsernameText}
                      radius='xl'
                      size={28}
                      color={avatarColor}
                    >
                      {Array.from(avatarUsernameText)[0].toUpperCase()}
                    </Avatar>

                    <div style={{ flex: 1 }}>
                      <Text size='sm' weight={500}>
                        {avatarUsernameText}
                      </Text>

                      <Text color='dimmed' size='xs'>
                        {avatarRoleText === Roles.MERCHANT_BRANCH &&
                        auth?.type === AccountTypes.MERCHANT_BRANCH
                          ? 'Merchant Branch'
                          : avatarRoleText.charAt(0).toUpperCase() +
                            avatarRoleText.slice(1).toLowerCase()}
                      </Text>
                    </div>

                    <ChevronDown size={12} />
                  </Group>
                </UnstyledButton>
              }
            >
              <Menu.Item
                data-cy='logoutButton'
                icon={<Logout size={14} />}
                onClick={handleLogout}
              >
                Logout
              </Menu.Item>
            </Menu>
          )}
        </Group>
      </div>
    </Header>
  );
};

export default AppHeader;
